import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

export const BarcodeDisplay = ({ value, format = "CODE128", width = 2, height = 50, displayValue = true, fontSize = 12 }) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (barcodeRef.current && value) {
      try {
        JsBarcode(barcodeRef.current, value, {
          format: format,
          width: width,
          height: height,
          displayValue: displayValue,
          fontSize: fontSize,
          margin: 5,
          background: "#ffffff",
          lineColor: "#000000",
        });
      } catch (error) {
        console.error("Barcode generation error:", error);
      }
    }
  }, [value, format, width, height, displayValue, fontSize]);

  if (!value) return null;

  return (
    <svg ref={barcodeRef} className="barcode-svg" />
  );
};

// مكون لعرض باركود المنتج مع خيارات
export const ProductBarcode = ({ barcode, productName, onPrint, onShare }) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (barcodeRef.current && barcode) {
      try {
        JsBarcode(barcodeRef.current, barcode, {
          format: "CODE128",
          width: 2,
          height: 60,
          displayValue: true,
          fontSize: 14,
          margin: 10,
          background: "#ffffff",
          lineColor: "#000000",
        });
      } catch (error) {
        console.error("Barcode error:", error);
      }
    }
  }, [barcode]);

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    const svgElement = barcodeRef.current;
    const svgData = new XMLSerializer().serializeToString(svgElement);

    printWindow.document.write(`
      <!DOCTYPE html>
      <html dir="rtl" lang="ar">
      <head>
        <title>باركود - ${productName}</title>
        <style>
          body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            margin: 0;
            font-family: Arial, sans-serif;
          }
          .product-name {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
            text-align: center;
          }
          .barcode-container {
            background: white;
            padding: 20px;
            border: 1px solid #ddd;
            border-radius: 8px;
          }
          @media print {
            body { margin: 0; padding: 10px; }
            .barcode-container { border: none; }
          }
        </style>
      </head>
      <body>
        <div class="barcode-container">
          <p class="product-name">${productName}</p>
          ${svgData}
        </div>
        <script>window.onload = () => window.print();</script>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  const handleShare = () => {
    const message = `📦 باركود المنتج
━━━━━━━━━━
📝 المنتج: ${productName}
🔢 الباركود: ${barcode}`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  if (!barcode) return <span className="text-slate-500">-</span>;

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="bg-white p-2 rounded">
        <svg ref={barcodeRef} />
      </div>
      <div className="flex gap-1">
        <button
          onClick={handlePrint}
          className="px-2 py-1 text-xs bg-slate-700 text-white rounded hover:bg-slate-600"
        >
          طباعة
        </button>
        <button
          onClick={handleShare}
          className="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-500"
        >
          واتساب
        </button>
      </div>
    </div>
  );
};

export default BarcodeDisplay;
